var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"pt-0 pb-0 pr-0",attrs:{"xl":"auto","lg":"auto","md":"auto","cols":"12"}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('v-col',{staticClass:"font-weight-bold pt-0 pb-0",attrs:{"xl":"auto","lg":"auto","md":"auto","cols":"12"}},[_vm._v(" "+_vm._s(_vm.value)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }